import { format as formatDate } from 'date-fns';

const formatNumberValue = numberValue => {
	return numberValue.toLocaleString(undefined, {
		minimumFractionDigits: 0, 
		maximumFractionDigits: 3
	});
}

const formatDateValue = date => {
	return formatDate(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export {
	formatNumberValue, formatDateValue
}